import { Component, OnInit, Input, Output, ViewChild } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl
} from "@angular/forms";
import { NzTreeComponent } from "ng-zorro-antd/tree";
import { NzFormatEmitEvent, NzTreeNodeOptions } from "ng-zorro-antd/core";
import {
  FieldWrapper,
  KreFormFieldConfig,
  KreTableFieldConfig
} from "@kre-form/core";
import { DataService } from "../../service/data.service";

@Component({
  selector: "kreform-area",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.less"],
  providers: [DataService]
})
export class KreFormArea implements OnInit {
  @Output() fieldConfig: KreFormFieldConfig = {};
  @ViewChild("nzTreeComponent", { static: false })
  nzTreeComponent: NzTreeComponent | undefined;

  nodes = [];
  constructor(public dataService: DataService) {}

  ngOnInit() {
    this.dataService.getTreeData().subscribe((res: any) => {
      this.nodes = res;
    });
  }
  nzEvent(event: NzFormatEmitEvent): void {}
  submitForm() {}
}
